import React, { useState, useEffect } from "react";
import { heading, tableData } from "../../../services/requestsTableData";
import ModelsSidebar from "../../models-Sidebar/models-sidebar";
import RequestTableBody from "../../Table/tableBodies/requestTableBody";
import BasicModal from "../../../components/models/models";
import {
  employeeRequestsData,
  teamEmpRequestsData,
  selectCompanyDashboard,
  getComRequestsPagewithoutParams,
  updatedCompanyRequests,
} from "../../../redux/slices/companyDashboardSlice";
import { motion, AnimatePresence } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../components/Table/table";
import Search from "../../../assets/images/search.png";

const initialState = {
  service: false,
  request_type: false,
  reason: false,
  // status: false,
};

function EmployeeRequestsModel({
  model = false,
  popup,
  setPopup,
  setstate,
  empId,
  dashboard,
}) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [popup1, setPopup1] = useState(false);
  const [orderType, setOrderType] = useState("asc");
  const [btns, setBtns] = useState(initialState);
  const [state, setState] = useState(0);
  const [id, setId] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const employeeState = useSelector(selectCompanyDashboard);
  const { employeeRequestData } = employeeState;
  const empRequests = transformResponse(employeeRequestData?.requests);
  const displayRequests = empRequests?.filter((request) =>
    request.service.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    if (dashboard == "companyDahboard") {
      dispatch(employeeRequestsData(empId));
    } else if (dashboard == "personalDashboard") {
      dispatch(teamEmpRequestsData(empId));
    } else {
      dispatch(getComRequestsPagewithoutParams());
    }
  }, [empId, popup1]);

  function transformResponse(response = []) {
    return response.map((item) => {
      return {
        id: item.id,
        userId: item.user_id,
        serviceId: item.service_id,
        service: {
          image: item.image_url,
          name: item.service_name,
          category: item.category,
        },
        type: item.request_type,
        status: item.status,
        reason: {
          heading: item.reason,
          subHeading: item.reason_details,
        },
        comment: item.comment == 0 ? "-" : item.comment,
        date: item.request_date,
      };
    });
  }

  const handleService = (orderType, set) => {
    setBtns({
      ...btns,
      user: true,
      // [active !== "user" && active]: false,
    });
    // setActive("user");
    let sort = null;
    if (orderType === "asc") {
      sort = [...employeeRequestData?.requests].sort((a, b) =>
        a.service_name.localeCompare(b.service_name)
      );
    } else {
      sort = [...employeeRequestData?.requests].sort((a, b) =>
        b.service_name.localeCompare(a.service_name)
      );
    }
    dispatch(updatedCompanyRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const handleRequestType = (orderType, set) => {
    setBtns({
      ...btns,
      user: true,
    });
    let sort = null;
    if (orderType === "asc") {
      sort = [...employeeRequestData?.requests].sort((a, b) =>
        a.request_type.localeCompare(b.request_type)
      );
    } else {
      sort = [...employeeRequestData?.requests].sort((a, b) =>
        b.request_type.localeCompare(a.request_type)
      );
    }
    dispatch(updatedCompanyRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const handleStatus = (orderType) => {
    setBtns({
      ...btns,
      status: true,
    });
    let sort = null;
    if (orderType === "asc") {
      sort = [...employeeRequestData?.requests].sort((a, b) =>
        a.status.localeCompare(b.status)
      );
    } else {
      sort = [...employeeRequestData?.requests].sort((a, b) =>
        b.status.localeCompare(a.status)
      );
    }
    dispatch(updatedCompanyRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const handleRequestReason = (orderType) => {
    setBtns({
      ...btns,
      reason: true,
    });
    let sort;
    if (orderType === "asc") {
      sort = [...employeeRequestData?.requests].sort((a, b) =>
        a.reason.localeCompare(b.reason)
      );
    } else {
      sort = [...employeeRequestData?.requests].sort((a, b) =>
        b.reason?.localeCompare(a.reason)
      );
    }
    dispatch(updatedCompanyRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const handleComment = (orderType) => {
    setBtns({
      ...btns,
      Comments: true,
      // [active !== "Comments" && active]: false,
    });
    // setActive("Comments");
    let sort = null;
    if (orderType === "asc") {
      sort = [...employeeRequestData?.requests].sort(
        (a, b) => a.comment - b.comment
      );
    } else {
      sort = [...employeeRequestData?.requests].sort(
        (a, b) => b.comment - a.comment
      );
    }
    dispatch(updatedCompanyRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const parseDate = (dateString) => {
    const dateData = dateString?.split("/");
    const [day, month, year] = dateData || [];
    return new Date(`${year}-${month}-${day}`);
  };

  const handleRequestDate = (orderType) => {
    setBtns({
      ...btns,
      request_date: true,
      // upDown: set ? !btns.upDown : false,
    });
    // setActive("request_date");
    const sort = [...employeeRequestData?.requests].sort((a, b) => {
      const dateA = parseDate(a.request_date);
      const dateB = parseDate(b.request_date);

      if (orderType === "asc") {
        return dateB - dateA;
      } else {
        return dateA - dateB;
      }
    });
    dispatch(updatedCompanyRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  const closeSidebar = () => {
    if (show === true) {
      setShow(false);
    }
  };

  return (
    <div className="relative sm:px-[20px] max-w-[90vw] w-auto 2xl:min-w-full 2xl:w-[1300px]">
      <div
        style={{
          height: "calc(100vh - 80px)",
        }}
        className="relative overflow-x-scroll pt-[81px] overflow-y-hidden scrollbar-hide bg-[#363D50] rounded-[12px] md:rounded-[16px] flex flex-row"
      >
        <div className="w-full">
          <div className="flex w-full absolute bg-[#363D50] z-[2] rounded-t-[16px] top-0 left-0 justify-between p-3 md:px-[24px] md:py-[16px] border-b-[1px] border-[#41485C]">
            <div className="flex flex-col">
              <span className="text-primary !text-left !text-[16px] sm:!text-[24px]">
                {employeeRequestData.user_name}'s requests
              </span>
              <span className="text-secondary !text-left">
                {employeeRequestData.total_count} totals
              </span>
            </div>
            <div className="flex h-[40px] justify-end items-center">
              <svg
                className="cursor-pointer"
                onClick={() => {
                  if (model) {
                    setShow(!show);
                  } else {
                    setPopup(false);
                    setState(15);
                  }
                }}
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4099 12.0002L17.7099 7.71019C17.8982 7.52188 18.004 7.26649 18.004 7.00019C18.004 6.73388 17.8982 6.47849 17.7099 6.29019C17.5216 6.10188 17.2662 5.99609 16.9999 5.99609C16.7336 5.99609 16.4782 6.10188 16.2899 6.29019L11.9999 10.5902L7.70994 6.29019C7.52164 6.10188 7.26624 5.99609 6.99994 5.99609C6.73364 5.99609 6.47824 6.10188 6.28994 6.29019C6.10164 6.47849 5.99585 6.73388 5.99585 7.00019C5.99585 7.26649 6.10164 7.52188 6.28994 7.71019L10.5899 12.0002L6.28994 16.2902C6.19621 16.3831 6.12182 16.4937 6.07105 16.6156C6.02028 16.7375 5.99414 16.8682 5.99414 17.0002C5.99414 17.1322 6.02028 17.2629 6.07105 17.3848C6.12182 17.5066 6.19621 17.6172 6.28994 17.7102C6.3829 17.8039 6.4935 17.8783 6.61536 17.9291C6.73722 17.9798 6.86793 18.006 6.99994 18.006C7.13195 18.006 7.26266 17.9798 7.38452 17.9291C7.50638 17.8783 7.61698 17.8039 7.70994 17.7102L11.9999 13.4102L16.2899 17.7102C16.3829 17.8039 16.4935 17.8783 16.6154 17.9291C16.7372 17.9798 16.8679 18.006 16.9999 18.006C17.132 18.006 17.2627 17.9798 17.3845 17.9291C17.5064 17.8783 17.617 17.8039 17.7099 17.7102C17.8037 17.6172 17.8781 17.5066 17.9288 17.3848C17.9796 17.2629 18.0057 17.1322 18.0057 17.0002C18.0057 16.8682 17.9796 16.7375 17.9288 16.6156C17.8781 16.4937 17.8037 16.3831 17.7099 16.2902L13.4099 12.0002Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>

          <div className="searchBox mt-2 md:mt-5 mx-3 md:mx-4">
            <img src={Search} alt="icon" className="searchIcon" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search requests"
              className="searchInput"
            />
          </div>

          <div className="px-[10px] overflow-y-scroll scrollbar-hide h-full">
            <Table
              setState={setState}
              setId={setId}
              setPopup={setPopup1}
              headings={heading}
              tableData={displayRequests}
              table={"request"}
              show={show}
              setShow={setShow}
              model={true}
              orderType={orderType}
              handleService={handleService}
              handleRequestType={handleRequestType}
              handleStatus={handleStatus}
              handleRequestReason={handleRequestReason}
              handleComment={handleComment}
              handleRequestDate={handleRequestDate}
            />

            {setPopup1 && (
              <BasicModal
                id={id}
                setId={setId}
                state={state}
                popup={popup1}
                setPopup={setPopup1}
                setState={setState}
                dashboard={dashboard}
                companyempid={empId}
              />
            )}
          </div>
        </div>

        <AnimatePresence>
          {show === true && (
            <motion.div
              className="w-full h-full absolute z-50 backdrop-blur-sm"
              initial={{ opacity: 0, x: 500 }}
              transition={{ duration: 0.3 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 500 }}
              onClick={closeSidebar}
            >
              <ModelsSidebar model={"request"} show={show} setShow={setShow} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default EmployeeRequestsModel;
